"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserProvider = void 0;
const core_1 = require("@qubic-js/core");
const cacheMiddleware_1 = __importDefault(require("./middlewares/cacheMiddleware"));
const IFrame_1 = __importDefault(require("./middlewares/IFrame"));
const PopupWindow_1 = __importDefault(require("./middlewares/PopupWindow"));
class BrowserProvider extends core_1.BaseProvider {
    constructor(options) {
        const { apiKey, apiSecret, chainId, infuraProjectId, enableIframe = false, walletUrl = core_1.WALLET_URL, inAppHintLink, } = options;
        const { hide, bridge, createPrepareBridgeMiddleware } = enableIframe
            ? new IFrame_1.default(apiKey, apiSecret, chainId, walletUrl, inAppHintLink)
            : new PopupWindow_1.default(apiKey, apiSecret, chainId, walletUrl, inAppHintLink);
        super({
            infuraProjectId,
            network: chainId,
            bridge,
            middlewares: [cacheMiddleware_1.default(bridge), createPrepareBridgeMiddleware()],
        });
        this.hide = () => hide();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const globalEthereum = typeof window !== 'undefined' ? window.ethereum : undefined;
        // when dapp browser open dapp which use qubic-sdk
        // it will use window.ethereum as default provider
        if (globalEthereum && (globalEthereum === null || globalEthereum === void 0 ? void 0 : globalEthereum.isQubic)) {
            globalEthereum.hide = () => null;
            return globalEthereum;
        }
    }
}
exports.BrowserProvider = BrowserProvider;
exports.default = BrowserProvider;
